import React from 'react';
import { Button } from '@iq/react-components';

const StepNavigator = ({ onBack, onNext, nextDisabled, nextLabel }) => (
  <div className="step-navigator">
    <div>
      {onBack ? (
        <Button
          activity="secondary"
          className="step-navigator__button-back"
          onClick={onBack}
        >
          {'Previous'}
        </Button>
      ) : null}
    </div>
    <div>
      {onNext ? (
        <Button
          onClick={onNext}
          className="step-navigator__button-next"
          disabled={nextDisabled}
        >
          {nextLabel || 'Next'}
        </Button>
      ) : null}
    </div>
  </div>
);

export default StepNavigator;
